import React, { useEffect, useRef, useState } from "react";
import {
  getAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import Constants from "../../../Constants";
import APIUrls from "../../../services/APIUrls";
import Header from "../../../components/global/Header";
import { EditPenIconReviewWorkflow,DownArrowIconWorkflow, RecycleIconRequestRevision, RightArrowRequestRevision, MinusRemoveStepWorkflow, PlusIconAddPhaseWorkflow, PlusIconLargeAddPhaseWorkflow, BackArrowIcon, ActiveAssigneeManIcon, InactiveCannotRequestRevisionIcon } from "../../../AppIcons";
import { transformBlankToNull } from "../../../services/Util";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
import { border } from "@mui/system";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../../ConditionalBlock";
export default function EditReviewWorkflow() {
  const scrollRef = useRef(null);
  const innerPopoverRefDuration = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const param = useParams();
  const [steps, setSteps] = useState([]);
  const [workflow, setWorkflow] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [newWorkFlowName, setNewWorkFlowName] = useState("");
  const [newWorkFlowDescription, setNewWorkFlowDescription] = useState("");
  const [defautSelectedDeparts, setDefaultSelectedDeparts] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [editablePhaseId, setEditablePhaseId] = useState("");
  const [showEditDuartion, setShowEditDuartion] = useState("");
  const [showEditAssignee, setShowEditAssignee] = useState("");
  const [showEditMultiAssignee, setShowEditMultiAssignee] = useState("");
  const [showEditReviewApprove, setShowEditReviewApprove] = useState("");
  const [showEditPermissions, setShowEditPermissions] = useState("");
  const [showEditRemovePhase, setShowEditRemovePhase] = useState("");
  const [showPhaseOnRemoval, setShowPhaseOnRemoval] = useState("");
  const [newPhaseDuration, setNewPhaseDuration] = useState("");
  const [showEditIcon, setShowEditIcon] = useState(true);
  const [enableRating, setEnableRating] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [allDeparts,setAllDeparts] = useState([])

const [selectedDepartment, setSelectedDepartment] = useState({
    label: "",
    value: "",
  });
  const options = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  
  const editWorkflow = useSelector(
    (updateReviewWorkflow) => updateReviewWorkflow.edit_review_workflow
  ).value;

  const toggleEditDuration = (stepIndex, phaseIndex) => {
    setShowEditMultiAssignee("");
    setShowEditAssignee("");
    setShowEditReviewApprove("");
    setShowEditPermissions("");
    setShowEditRemovePhase("");
    setShowPhaseOnRemoval("");
    `step${stepIndex}phase${phaseIndex}` === showEditDuartion
      ? setShowEditDuartion("")
      : setShowEditDuartion(`step${stepIndex}phase${phaseIndex}`);
  };
  const toggleAssignee = (e,stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
    setShowEditMultiAssignee("");
    setShowEditReviewApprove("");
    setShowEditPermissions("");
    setShowEditRemovePhase("");
    setShowPhaseOnRemoval("");
    setShowEditDuartion("");

    `step${stepIndex}phase${phaseIndex}` === showEditAssignee
      ? setShowEditAssignee("")
      : setShowEditAssignee(`step${stepIndex}phase${phaseIndex}`);
    }  
  };
  const toggleAssigneeMulti = (e,stepIndex, phaseIndex) => {
    if(e.type === 'click' || (e.type === 'keydown' && e.key === Constants.ENTER) || ($('.popover-body.show').length && e.key === Constants.ESCAPE)){
    setShowEditAssignee("");
    setShowEditReviewApprove("");
    setShowEditPermissions("");
    setShowEditRemovePhase("");
    setShowPhaseOnRemoval("");
    setShowEditDuartion("");

    `step${stepIndex}phase${phaseIndex}` === showEditMultiAssignee
      ? setShowEditMultiAssignee("")
      : setShowEditMultiAssignee(`step${stepIndex}phase${phaseIndex}`);
    }  
  };
  const toggleReviewApprove = (e,stepIndex, phaseIndex) => {
    if (e.key===Constants.ENTER || e.type==="click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
    setShowEditAssignee("");
    setShowEditMultiAssignee("");
    setShowEditPermissions("");
    setShowEditRemovePhase("");
    setShowPhaseOnRemoval("");
    setShowEditDuartion("");
    `step${stepIndex}phase${phaseIndex}` === showEditReviewApprove
      ? setShowEditReviewApprove("")
      : setShowEditReviewApprove(`step${stepIndex}phase${phaseIndex}`);
    }  
  };
  const togglePermission = (e,stepIndex, phaseIndex) => {
    if(e.type === 'click' || (e.type === 'keydown' && e.key === Constants.ENTER) || ($('.popover-body.show').length && e.key === Constants.ESCAPE)){
    setShowEditAssignee("");
    setShowEditMultiAssignee("");
    setShowEditReviewApprove("");
    setShowEditRemovePhase("");
    setShowPhaseOnRemoval("");
    setShowEditDuartion("");
    `step${stepIndex}phase${phaseIndex}` === showEditPermissions
      ? setShowEditPermissions("")
      : setShowEditPermissions(`step${stepIndex}phase${phaseIndex}`);
    }   
  };
  const closeOpenPupup = (type) => {
    if (type === "all") {
      setShowEditAssignee("");
      setShowEditMultiAssignee("");
      setShowEditReviewApprove("");
      setShowEditPermissions("");
      setShowEditRemovePhase("");
      setShowEditDuartion("");
      setShowPhaseOnRemoval("");
    }
  };
  const handleClickOutside = (event) => {
    const list = event.target.classList.contains("workflow-wrap");
    const list1 = event.target.classList.contains("setting-review-flow");
    const list2 = event.target.classList.contains("flex-align-center");
    const box = event.target.classList.contains("step-box-list");
    const button = event.target.classList.contains("workflow-step-content");
    const paperroot = event.target.classList.contains("popup-padding");
    const create_workflow = event.target.classList.contains(
      "create-new-review-workflow"
    );
    // const svgItem = event.target.closest('.MuiSvgIcon-root');
    const dashboard = event.target.classList.contains("flex");
    if (
      list ||
      list1 ||
      list2 ||
      box ||
      dashboard ||
      button ||
      paperroot ||
      create_workflow
    ) {
      closeOpenPupup("all");
    }
  };
  document.addEventListener("click", handleClickOutside, true);

  const toggleEditRemovePhase = (e,stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
    setShowEditAssignee("");
    setShowEditMultiAssignee("");
    setShowEditReviewApprove("");
    setShowEditPermissions("");
    setShowPhaseOnRemoval("");
    setShowEditDuartion("");
    `step${stepIndex}phase${phaseIndex}` === showEditRemovePhase ? setShowEditRemovePhase("") : setShowEditRemovePhase(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const togglePhaseOnRejection = (e,stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
      setShowEditAssignee("");
      setShowEditMultiAssignee("");
      setShowEditReviewApprove("");
      setShowEditPermissions("");
      setShowEditRemovePhase("");
      setShowEditDuartion("");
      `step${stepIndex}phase${phaseIndex}` === showPhaseOnRemoval
        ? setShowPhaseOnRemoval("")
        : setShowPhaseOnRemoval(`step${stepIndex}phase${phaseIndex}`);
    }  
  };
  const showTextBox = (prop) => {
    if (`step${prop.stepIndex}phase${prop.phaseIndex}` === editablePhaseId) {
      setShowEditIcon(true);
      setEditablePhaseId("");
    } else {
      setEditablePhaseId(`step${prop.stepIndex}phase${prop.phaseIndex}`);
    }
    setShowEditRemovePhase("");
  };

  const setAutomaticSync = (e) => {
    e.persist();
  setIsChecked(e.target.checked);
  };
   const editEnableRating = (e) => {
    setEnableRating(e.target.checked);
  };
  const selectAssignee = (e, phaseIndex, stepIndex) => {
    var selectedAssignee = {};
    var copySteps = steps;
    var value = ''
    if(e.type === "keydown" && e.key === Constants.ENTER){
      value = e.target.htmlFor
    }else if(e.type === 'change') {
      value = e.target.value
    }
    else{
      return ;
    }
    if (value === "CUSTOMER_USER") {
      selectedAssignee = {
        type: "CUSTOMER_USER",
        display: "Internal",
        code: "customer_user",
      };
    } else {
      selectedAssignee = { type: "VENDOR", display: "Vendor", code: "vendor" };
      copySteps[stepIndex].phases[phaseIndex].allowMultiAssignee = false;
    }
    copySteps[stepIndex].phases[phaseIndex].assigneeType = selectedAssignee;
    setSteps(copySteps);
    setShowEditAssignee("");
    $(`#assignee_step${stepIndex}phase${phaseIndex}`).focus()
  };
  const selectMultiAssignee = (e,selectedValue, prop) => {
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change' || e.key=== "click"){
      value = selectedValue
    }
    else{
      return ;
    }
    var copyStep = structuredClone(steps);
    if (value) {
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowMultiAssignee = true;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = false;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].reviewmode_editable = false;
    }
    else{
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowMultiAssignee = false;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = true;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].reviewmode_editable = true;
    }
    setSteps(copyStep);
    setShowEditMultiAssignee("");
    $(`#step${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const changeStepName = (value, stepIndex) => {
    var copySteps = structuredClone(steps);
    copySteps[stepIndex].name = value;
    setSteps(copySteps);
  };
  const changePhaseName = (value, stepIndex, phaseIndex) => {
    var copySteps = structuredClone(steps);
    copySteps[stepIndex].phases[phaseIndex].name = value;
    setSteps(copySteps);
  };
  function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); } 
  const saveDuration = (stepIndex, phaseIndex) => {
    if(isNumber(newPhaseDuration)){
    var copySteps = structuredClone(steps);
    copySteps[stepIndex].phases[phaseIndex].durationInDays = newPhaseDuration;
    setSteps(copySteps);
    setShowEditDuartion("");
    }
  };
  const selectPermission = (e,selectedValue, prop) => {
    var copyStep = structuredClone(steps);
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change' ){
      value = selectedValue
    }else if(($('.popover-body.show').length && e.key === Constants.ESCAPE)){
      setShowEditPermissions("");
      return ;
    }
    else{
      return;
    }
    if(value){
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = true;
    }
    else{
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = false;
    }
    setSteps(copyStep);
    setShowEditPermissions("");
    $(`#permission${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const selectPhaseType = (e,selectedValue, prop) => {
    var copyStep = {};
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change'){
      value = selectedValue
    }
    else{
      return ;
    }
    if (value) {
      copyStep = getReturnPhases(prop.step,prop.stepIndex,prop.phase,prop.phaseIndex);
      copyStep[prop.stepIndex].phases[prop.phaseIndex].isApprovalPhase = true;
    }
    else{
      copyStep = structuredClone(steps);
      copyStep[prop.stepIndex].phases[prop.phaseIndex].isApprovalPhase = false;
    }
    setSteps(copyStep);
    setShowEditReviewApprove("");
    $(`#review${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const selectReturnPhase = (e,selectedValue, prop,step) => {
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change'){
      value = selectedValue
    }
    else{
      return ;
    }
    var filterdDisplay = step[prop.stepIndex].phases[prop.phaseIndex].returnPhases.filter((returns) => {
      return Number(returns.phaseNumber) === Number(value);
    });
    step[prop.stepIndex].phases[prop.phaseIndex].returnPhaseNumber = value;
    step[prop.stepIndex].phases[prop.phaseIndex].returnPhaseDisplay =
      filterdDisplay[0].displayText;
    setSteps(step);
    setShowPhaseOnRemoval("");
    $(`#return${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const EditAssigneeComponent = (prop) => {
    return (
      <div
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={"CUSTOMER_USER"}
                checked={
                  prop.defaultSelectedPhase.assigneeType?.originalEnum ===
                    "CUSTOMER_USER" ||
                  prop.defaultSelectedPhase.assigneeType?.type ===
                    "CUSTOMER_USER"
                }
                id={"CUSTOMER_USER"}
                onChange={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex)}}
              />
              <label className="form-check-label" htmlFor={"CUSTOMER_USER"} tabIndex={0}
               onKeyDown={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex)}}>
                Internal
              </label>
            </div>
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={"VENDOR"}
                checked={
                  prop.defaultSelectedPhase.assigneeType?.originalEnum ===
                    "VENDOR" ||
                  prop.defaultSelectedPhase.assigneeType?.type === "VENDOR"
                }
                id={"VENDOR"}
                onChange={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex);
                }}
              />
              <label className="form-check-label" htmlFor={"VENDOR"} tabIndex={0}
              onKeyDown={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex)}}>
                Vendor
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditMultiAssignee = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show multi"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={false}
                checked={prop.phase.allowMultiAssignee === false}
                id={"single"}
                onChange={(e) => {selectMultiAssignee(e,false, prop)}}
              />
              <label className="form-check-label" htmlFor={"single"} tabIndex={0}
              onKeyDown={(e) => {selectMultiAssignee(e,false, prop)}}>
                Single Assignee
              </label>
            </div>
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={true}
                checked={prop.phase.allowMultiAssignee === true}
                id={"multi"}
                onChange={(e) => {selectMultiAssignee(e,true,prop)}}
              />
              <label className="form-check-label" htmlFor={"multi"} tabIndex={0}
              onKeyDown={(e) => {selectMultiAssignee(e,true, prop)}}>
                Multiple Assignees and Timed Phases
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditReviewApprove = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={false}
                checked={prop.phase.isApprovalPhase === false}
                id="review"
                onChange={(e) => {selectPhaseType(e.target.value, prop)}}
              />
              <label className="form-check-label" htmlFor="review" tabIndex={0} onKeyDown={(e)=>selectPhaseType(e,false, prop)}>
                Review
              </label>
            </div>
            {prop.phase.phaseNumber > 2 ? (
              <div className="radio-form-check">
                <input
                  tabIndex={-1}
                  type="radio"
                  className="form-check-input"
                  value={true}
                  checked={prop.phase.isApprovalPhase === true}
                  id="approve"
                  onChange={(e) => {selectPhaseType(e.target.value, prop)}}
                />
                <label className="form-check-label" htmlFor="approve" tabIndex={0} onKeyDown={(e)=>selectPhaseType(e,true, prop)}>
                  Approval
                </label>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  const EditPermission = (prop) => {
    return (
      <div className="popover-body show" >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input tabIndex={-1} type="radio" className="form-check-input" value={true}
                checked={ prop.phase.isApprovalPhase === true || prop.phase.allowRevision === true }
                id={"internal"} onChange={(e) => { selectPermission(e,true, prop); }}
              />
              <label className="form-check-label" htmlFor={"internal"} tabIndex={0} 
               onKeyDown={(e) => {selectPermission(e,true,prop)}}>
                Can Request Revision
              </label>
            </div>

            <div className="radio-form-check">
              <input
                type="radio"
                tabIndex={-1}
                className="form-check-input"
                value={false}
                checked={prop.phase.allowRevision === false}
                id={"vendor"}
                onChange={(e) => {
                  selectPermission(e,false, prop);
                }}
              />
              <label className="form-check-label" htmlFor={"vendor"} tabIndex={0} 
               onKeyDown={(e) => {selectPermission(e,false,prop)}}>
                Cannot Request Revision
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditRemovePhase = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover w-160">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <Link onClick={() => showTextBox(prop)}>Edit Name</Link>
            </div>
            {steps[prop.stepIndex].phases.length > 2 ? (
              <div className="radio-form-check">
                <Link onClick={() => removePhase(prop)}>Remove Phase</Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  const departActive = () =>{
    if(options.features && options.features.USER_GROUPS) {
       if(allDeparts.length > 1 || (allDeparts.length === 1 && allDeparts[0].id !== options.systemUserGroup.id)) {
        return true;
       }
    }
  return false;
  }
  const EditPhaseOnRejection = (prop) => {
    var copyStep = getReturnPhases(prop.step,prop.stepIndex,prop.phase,prop.phaseIndex);
    return (
      <div
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            {copyStep[prop.stepIndex].phases[prop.phaseIndex].returnPhases.map((returnPhase, i) => {
              return (
                <div className="radio-form-check" key={i}>
                  <input
                    type="radio"
                    tabIndex={-1}
                    className="form-check-input"
                    value={returnPhase.phaseNumber}
                    checked={
                      prop.phase.returnPhaseNumber !== ""
                        ? Number(prop.phase.returnPhaseNumber) ===
                          Number(returnPhase.phaseNumber)
                        : i === 0
                    }
                    id={returnPhase.phaseNumber}
                    onChange={(e) => {selectReturnPhase(e,returnPhase.phaseNumber, prop,copyStep)}}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={returnPhase.phaseNumber}
                    tabIndex={0}
                    onKeyDown={(e) => {selectReturnPhase(e,returnPhase.phaseNumber,prop,copyStep)}}
                    dangerouslySetInnerHTML={{
                      __html: returnPhase.displayText,
                    }}
                  ></label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  
  $(document).on("click",".cw__control",function() {
    $('.project-setting-page').addClass('pb-250');
 });
 
 $(document).mouseup(function(e) {
  var bannerCont = $('.cw__input');
  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
    $('.project-setting-page').removeClass('pb-250')
  }
});
 
  const selectDepartments = (value) => {
    if (value.value === "all") {
      departments.map((depart) => {
        if (depart.value !== "all") {
          setDefaultSelectedDeparts((current) => [...current, depart.value]);
        }
      });
      setDepartments([]);
    } else {
      if(departments.length === 3){
        var remainDepart = departments.filter((depart) => depart.value !== 'all')
        setDepartments(remainDepart)
      }
      setDefaultSelectedDeparts((current) => [...current, value.value]);
      setDepartments((current) =>
        current.filter((depart) => depart.value.id !== value.value.id)
      );
      
    }
    setSelectedDepartment(value.value);
    $("body").removeClass("static-footer-btn");
    $('.project-setting-page').removeClass('pb-250')
  };

  const removeDepartment = (value) => {
    var departs = [...departments]
    setSelectedDepartment({label:'',value:''})
    setDefaultSelectedDeparts((current) =>
      current.filter((depart) => depart.id !== value.id)
    );
    if (value !== "all") {
      departs.push({ label: value.name, value: value })
      const strAscending = [...departs].sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1 ,
      );
      const isFound = departments.some(element => {
        if (element.value === 'all') {
          return true;
        }
        return false;
      });
      
      if (departments.length > 1 && !isFound) {
        strAscending.unshift({ label: "Select - All", value: "all" });
      }else{
        const fromIndex = strAscending.findIndex(object => {
          return object.value === 'all';
        });
          const toIndex = 0;
          const element = strAscending.splice(fromIndex, 1)[0];
          strAscending.splice(toIndex, 0, element);
      }
      setDepartments(strAscending);
    }
    
  };
  const getAllDepartments = (defaultSelected) => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        if (res.data !== "") {
          setAllDeparts(res.data.data)
          var options = [];
          var result = res.data.data.filter(
            (id1) => !defaultSelected?.some((id2) => id1.id === id2.id)
          );
          if(result.length > 1){
             options = [{ label: "Select - All", value: "all" }];
          }

          result.map((depart) => {
            options.push({
              label: depart.name,
              value: depart,
            });
          });
          setDepartments(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(param.id))
      .then((res) => {
        if (res.data !== "") {
          setWorkflow(res.data.data);
          setEnableRating(res.data.data.enableRating);
          setSteps(res.data.data.steps);
          setDefaultSelectedDeparts(res.data.data.userGroups);
          getAllDepartments(res.data.data.userGroups);
          res.data.data.steps.map((step, stepIndex) => {
            step.phases.map((phase, phaseIndex) => {
              if (phase.isApprovalPhase) {
                getReturnPhases(
                  step,
                  stepIndex,
                  phase,
                  phaseIndex,
                  res.data.data.steps
                );
              }
            });
          });
          setIsChecked(res.data.data.enableAutomaticTmSync);
       }
      })
      .catch((err) => {
        handleError(err);
      });
    $('.lastdisable').trigger('focus');
  }, []);

  const isFullWorkflowEditEnabled = () => {
    if(options.features !== undefined){
      if(options.features.CUSTOM_WORKFLOW && workflow?.workflowType?.code === "custom"){
        return true
      }else{
        return false
      }
    }
    
  };
  const isAutomaticTmSync = () => {
    if(options.features !== undefined){
      if(options?.features?.AUTOMATIC_TM_SYNC === true){
        return true
      }else{
        return false
      }
    }
  }

  const reviewModeEditable = (phase, step, index) => {
    var val=
      phase?.phaseNumber !== 1 &&
      index + 1 < step?.phases?.length &&
      phase?.isApprovalPhase !== true
        ? true
        : false;

    if (phase?.allowMultiAssignee === true) {
      val = false;
    }
    return val;
  };
  const multiAssigneeEditable = (step, phase, index) => {
    if (
      (step.stepNumber !== 1 || phase.phaseNumber !== 1) &&
      ((phase.assigneeType &&
        phase.assigneeType.originalEnum &&
        phase.assigneeType.originalEnum === "CUSTOMER_USER") ||
        (phase.assigneeType &&
          phase.assigneeType.type &&
          phase.assigneeType.type === "CUSTOMER_USER")) &&
      phase.phaseNumber !== 1 &&
      index + 1 < step.phases.length
    ) {
      return true;
    } else {
      return false;
    }
  };
  const addPhase = (stepIndex) => {
    var copySteps = structuredClone(steps);
    var returnPhases = [];
    copySteps[stepIndex].phases.map((phase) => {
      returnPhases.push({
        phaseNumber: phase.phaseNumber,
        name: phase.phaseType.display,
        displayText: `Phase ${phase.phaseNumber}&nbsp;(${phase.phaseType.display})`,
      });
    });
    var newPhase = {
      phaseNumber: copySteps[stepIndex].phases.length + 1,
      assigneeType: null,
      durationInDays: "",
      phaseType: { display: "Review", code: "review", originalEnum: "REVIEW" },
      allowMultiAssignee: false,
      allowRevision: true,
      applicationVersion: null,
      assigneeUsers: null,
      assigneeVendor: null,
      createdDate: null,
      customer: null,
      id: null,
      isApprovalPhase: false,
      lastModifiedDate: null,
      name: "",
      path: null,
      returnPhaseNumber: "",
      returnPhases: returnPhases,
      timed: false,
    };
    copySteps[stepIndex].phases.push(newPhase);
    setSteps(copySteps);
  };
  const removePhase = (prop) => {
    var copySteps = structuredClone(steps);
    var newPhases = [];
    var remainingReturnPhases = [];

    var remainingPhases = copySteps[prop.stepIndex].phases.filter((phase) => {
      return phase.phaseNumber !== prop.phase.phaseNumber;
    });

    remainingPhases.map((phase, index) => {
      phase.phaseNumber = index + 1;
      if (
        phase.returnPhaseNumber &&
        Number(phase.returnPhaseNumber) === Number(prop.phase.phaseNumber)
      ) {
        phase.returnPhaseNumber = "";
        if (phase.returnPhases.length !== 0) {
          remainingReturnPhases = phase.returnPhases.filter((returnPhase) => {
            return returnPhase.phaseNumber !== prop.phase.phaseNumber;
          });
        }
        phase.returnPhases = remainingReturnPhases;
      }
      newPhases.push(phase);
    });
    copySteps[prop.stepIndex].phases = newPhases;
    setSteps(copySteps);
  };
  const removeStep = (stepIndex, stepNumber) => {
    var copySteps = structuredClone(steps);
    var remainingSteps = [];
    var orderedSteps = [];
    remainingSteps = copySteps.filter((step) => {
      return step.stepNumber !== stepNumber;
    });
    remainingSteps.map((step, index) => {
      step.stepNumber = index + 1;
      step.name = `Step ${index + 1}`;
      orderedSteps.push(step);
    });
    setSteps(orderedSteps);
  };
  const addStep = () => {
    var stepsLength = steps.length;
    var newStep = {
      stepNumber: stepsLength + 1,
      name: "",
      placeHolder: `Step ${stepsLength + 1}`,
      phases: [
        {
          phaseNumber: 1,
          assigneeType: null,
          allowRevision: false,
          phaseType: {
            originalEnum: "WORK",
            display: "Work",
            code: "work",
          },
          assignee_editable: true,
          duration_editable: true,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of work",
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Work",
          returnPhases: [],
          durationInDays: "",
        },
        {
          phaseNumber: 2,
          returnPhases: [
            {
              phaseNumber: 1,
              name: "Work",
              displayText: "Phase 1&nbsp;(Work)",
            },
          ],
          assigneeType: null,
          phaseType: {
            originalEnum: "REVIEW",
            display: "Review",
            code: "review",
          },
          assignee_editable: true,
          duration_editable: true,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of review",
          allowRevision: true,
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Final Review",
          durationInDays: "",
        },
      ],
      removable: true,
      name_editable: true,
    };
    var copySteps = structuredClone(steps);
    copySteps.push(newStep);
    setSteps(copySteps);
  };
  const saveWorkflow = (redirect) => {
    var copyworkflow = { ...workflow };
    copyworkflow.steps = steps;
    copyworkflow.userGroups = defautSelectedDeparts;
    copyworkflow.enableAutomaticTmSync= isChecked;
    if (newWorkFlowName !== "") {
      copyworkflow.name = newWorkFlowName;
    }
    if (newWorkFlowDescription !== "") {
      copyworkflow.description = newWorkFlowDescription;
    }
    copyworkflow.enableRating = enableRating;
    var payload = transformBlankToNull(copyworkflow);
    putAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(param.id), payload).then(
      (res) => {
        if (res.data.data && res.data.data.body && res.data.data.body.success === false) {
          setValidationErrors(res.data.data.body.errors);
        } else {
          if(redirect === ''){
            navigate("/settings/review-workflow");
          }
          else{
            navigate(`/settings/workflow/language-review-workflow/${param.id}`)
          }
        }
      }
    );
  };
  const getPhaseName = (step, selectedPhase) => {
    var returnPhase = step.phases.filter((phase) => {
      return phase.phaseNumber == selectedPhase.returnPhaseNumber;
    });
    return `Phase ${returnPhase[0].phaseNumber} (${returnPhase[0].phaseType.display})`;
  };
  const getReturnPhases = (step, stepIndex, phase, phaseIndex) => {
    var copySteps = structuredClone(steps);
    if(copySteps[stepIndex]){
    copySteps[stepIndex].phases[phaseIndex] = {...copySteps[stepIndex].phases[phaseIndex],returnPhases:[]}
    step.phases.map((previousePhase, index) => {
      if (previousePhase.phaseNumber < phase.phaseNumber) {
        var returnPhase = {
          phaseNumber: previousePhase.phaseNumber,
        };
        if (phase.name !== "") {
          returnPhase.name = previousePhase.name;
        } else {
          returnPhase.name = previousePhase.phaseType.display;
        }
        returnPhase.displayText =
          "Phase " +
          returnPhase.phaseNumber +
          "&nbsp;(" +
          returnPhase.name +
          ")";

        if (
          phase.returnPhaseNumber &&
          phase.returnPhaseNumber === returnPhase.phaseNumber
        ) {
          copySteps[stepIndex].phases[phaseIndex].returnPhaseDisplay = returnPhase.displayText;
        }
        copySteps[stepIndex]?.phases[phaseIndex]?.returnPhases.push(returnPhase);
      }
    });
    return copySteps;
  }
  };
  
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Review workflow template', url:'settings/review-workflow'},
    {label:'Edit workflow template', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button aria-label="back" onClick={() => navigate("/settings/review-workflow")}>
                   {BackArrowIcon}
                  </button>
                  <span>Return to Review Workflow Templates</span>
                </div>
                <h3 className="flex">Edit {workflow.name}</h3>
                <span>Set up your workflow template.</span>
              </div>
              <div className="white-bg">
                <div className="create-new-review-workflow">
                  <div className="wrap-input-text-group mar-bot20">
                    <label>Name</label>
                    <div className="input-text-group flex">
                      <input type="text" aria-required={true} aria-label="name"
                        className="form-control-sm" title="name" maxLength={50} defaultValue={workflow.name}
                        disabled={!isFullWorkflowEditEnabled()} onChange={(e) => setNewWorkFlowName(e.target.value)}/>
                    </div>
                  </div>
                  <div className="wrap-input-text-group mar-bot20">
                    <label>Description</label>
                    <div className="input-text-group flex">
                      <textarea maxLength={255} aria-label="description" className="textarea max-680" defaultValue={workflow.description}
                        onChange={(e) => setNewWorkFlowDescription(e.target.value)} disabled={!isFullWorkflowEditEnabled()}
                      ></textarea>
                    </div>
                    <ConditionalBlock condition={isFullWorkflowEditEnabled()}>
                      <div>{`${255 - newWorkFlowDescription.length}`} {255 - newWorkFlowDescription.length > 1 ? 'characters left' : 'character left'}</div>
                    </ConditionalBlock> 
                  </div>
                  <div className="project-heading">
                    <h6>Workflow Steps</h6>
                    <ConditionalBlock condition={isFullWorkflowEditEnabled()}>
                      <p>
                        Select the name, duration and assignee of each workflow
                        step in the template. Users creating projects will see
                        this configuration, and will be able to edit the due dates
                        and assignees to fit their project.
                      </p>
                    </ConditionalBlock>
                    <ConditionalBlock condition={validationErrors.steps}>
                      <p className="error">{validationErrors.steps}</p>
                    </ConditionalBlock>
                  </div>
                  <div className="workflow-wrap flex-align-center setting-review-flow">
                    {steps.map((step, stepIndex) => {
                      return (
                        <React.Fragment key={stepIndex}>
                          <div className="workflow-step-list open-step flex">
                            <div className="inner-step-list">
                              <input className="step-btn form-group" type="text" maxLength={25} disabled={!isFullWorkflowEditEnabled()}
                                defaultValue={step.name !== "" ? step.name : `Step ${step.stepNumber}`} aria-label="workflow step name"
                                style={validationErrors["steps." + stepIndex + ".name"] !== undefined? { border: "2px solid #A61616" }: {}} onChange={(e) => changeStepName(e.target.value, stepIndex)}  />
                              <div className="workflow-step-content popup-padding flex">
                                {step.phases.map((phase, index) => {
                                  return (
                                    <div className="step-box-list" key={index}>
                                      {isFullWorkflowEditEnabled &&
                                      (step.stepNumber !== 1 || phase.phaseNumber !== 1) ? (
                                        <div className="workflowName step-assignee" ref={innerPopoverRefDuration} >
                                          <button style={validationErrors["steps." +stepIndex +".phases." +index +".durationInDays"] !== undefined? { border: "2px solid #A61616",} : {}} className="step-cal flex-center" aria-label="Duration picker" aria-expanded={showEditDuartion === `step${stepIndex}phase${index}` ? true : false}
                                            disabled={!isFullWorkflowEditEnabled()} onClick={() =>toggleEditDuration(stepIndex,index)} >
                                            {" "} {phase.durationInDays !== "" ? 
                                            (
                                              <span>
                                                {phase.durationInDays} days
                                              </span>
                                            ) : 
                                            (
                                              <span>Duration</span>
                                            )}
                                          </button>
                                          {showEditDuartion === `step${stepIndex}phase${index}` ? (
                                            <div id={phase.id} className="popover-body show" >
                                              <div className="inner-popover">
                                                <h4>Duration of review</h4>
                                                <div>
                                                  <div className="flex mar-bot10">
                                                    <input type="text" style={{width:"40%"}} className="form-control-sm" aria-label="enter duration in days"  maxLength="3" onChange={(e) =>setNewPhaseDuration(parseInt(e.target.value))}
                                                      defaultValue={phase?.durationInDays} disabled={!isFullWorkflowEditEnabled()} />
                                                    {" "}
                                                    <div style={{padding:"5px 10px 10px"}}>Days</div>
                                                  </div>
                                                  <div className="left flex btn-gap justify-end" style={{ padding: "5px" }}>
                                                    <button className="blue-btn triggerBtn" disabled={!isFullWorkflowEditEnabled()} onClick={() =>{setShowEditDuartion("");setNewPhaseDuration('')}}>
                                                      Cancel
                                                    </button>
                                                    <button className="blue-btn active" disabled={!isFullWorkflowEditEnabled()} onClick={() => saveDuration(stepIndex,index)}>
                                                      Save
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                        </div>
                                      ) : phase.durationInDays !== "" ? (
                                        <span>{phase.durationInDay} days</span>
                                      ) : null}

                                      <div className="step-assignee flex-center"
                                            role="button" 
                                            tabIndex={isFullWorkflowEditEnabled() && editablePhaseId === '' ? 0 : -1}
                                            aria-expanded={showEditRemovePhase === `step${stepIndex}phase${index}` ? true : false}
                                            onClick={isFullWorkflowEditEnabled() && editablePhaseId === '' ? (e) => toggleEditRemovePhase(e,stepIndex,index) : null}
                                            onKeyDown={isFullWorkflowEditEnabled() && editablePhaseId === '' ? (e) =>toggleEditRemovePhase(e,stepIndex,index) : null}
                                            >
                                        {editablePhaseId ===`step${stepIndex}phase${index}` ? (
                                          <input type="text" className="form-control-sm" maxLength={20}
                                            defaultValue={(phase.name !== undefined && phase.name !== "") ? phase.name : phase.phaseNumber === step.phases.length ? "Final Review" : phase?.phaseType?.display} 
                                            onChange={(e) => changePhaseName(e.target.value,stepIndex,index)} onBlur={() => setEditablePhaseId("") } />
                                        ) : (
                                         <>
                                            {phase.name !== undefined &&
                                            phase.name !== "" ? (
                                              <span className="phaseName">
                                                {phase.name}
                                              </span>
                                            ) : phase.phaseNumber === step.phases.length ? (
                                              <span className="finalPhaseName">
                                                Final Review
                                              </span>
                                            ) : (
                                              <span className="phaseDisplay">
                                                {phase.phaseType.display}
                                              </span>
                                            )}
                                            </>)}

                                             {isFullWorkflowEditEnabled() ? 
                                                <>
                                                <button className="inline-flex" aria-label="edit" tabIndex="-1"
                                                onClick={() =>setEditablePhaseId("")}>
                                                {showEditIcon ? (
                                                  EditPenIconReviewWorkflow
                                                ) : null}
                                                </button>
                                                {showEditRemovePhase === `step${stepIndex}phase${index}` ? (
                                                  <EditRemovePhase phaseIndex={index} stepIndex={stepIndex} phase={phase}/>
                                                ) : null}
                                                </>
                                              : null
                                        } 
                                        
                                      </div>
                                      {isFullWorkflowEditEnabled() &&
                                      !(step.stepNumber === 1 && phase.phaseNumber === 1 ) ? (
                                        phase.assigneeType !== "" ? (
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center " role="button" tabIndex={isFullWorkflowEditEnabled() ? 0 : -1}
                                              id={`assignee_step${stepIndex}phase${index}`}
                                              aria-label={phase.assigneeType !== undefined && phase.assigneeType !== null ? phase?.assigneeType?.display+' ,phase assignee' : "phase assignee"}
                                              aria-expanded={showEditAssignee === `step${stepIndex}phase${index}` ? true : false}
                                              style={validationErrors["steps." +stepIndex +".phases." +index +".assigneeType"] !== undefined ? { border:"2px solid #A61616",padding: "0px 2px",borderRadius: "5px"}: {} }
                                              onClick={isFullWorkflowEditEnabled() ? (e) => toggleAssignee(e,stepIndex,index): null}
                                              onKeyDown={isFullWorkflowEditEnabled() ? (e) =>toggleAssignee(e, stepIndex, index) : null}
                                            >
                                              <span className="select"> 
                                                {phase.assigneeType !== undefined && phase.assigneeType !== null ? phase?.assigneeType?.display : "Assignee"}
                                              </span>
                                              {DownArrowIconWorkflow} 
                                            </div>

                                            {showEditAssignee === `step${stepIndex}phase${index}` ? (
                                              <EditAssigneeComponent
                                                defaultSelectedPhase={phase}
                                                phaseIndex={index}
                                                defaultSelectedStepIndex={
                                                  stepIndex
                                                }
                                              />
                                            ) : null}
                                          </div>
                                        ) : (
                                          <span>Error Assignee</span>
                                        )
                                      ) : phase.assigneeType !== "" ? (
                                        <strong>
                                          {phase?.assigneeType?.display}
                                        </strong>
                                      ) : (
                                        <strong>Assignee</strong>
                                      )}
                                      <div className="step-assignee ">
                                        <div
                                          id={`step${stepIndex}phase${index}`} className="step-assignee flex-center justify-center"
                                          role="button" aria-label={phase.allowMultiAssignee ? "Multi Assignee" : "Single Assignee"}
                                          aria-expanded={showEditMultiAssignee === `step${stepIndex}phase${index}` ? true : false}
                                          tabIndex={options?.features?.MULTI_ASSIGNEE_PHASE ? isFullWorkflowEditEnabled && multiAssigneeEditable(step,phase,index) ? 0 : -1 : -1}
                                          onClick={(e) =>options?.features ?.MULTI_ASSIGNEE_PHASE ? isFullWorkflowEditEnabled() && multiAssigneeEditable(step,phase,index) ? toggleAssigneeMulti(e,stepIndex,index) : null : null }
                                          onKeyDown={(e) =>options?.features ?.MULTI_ASSIGNEE_PHASE ? isFullWorkflowEditEnabled() && multiAssigneeEditable(step,phase,index) ? toggleAssigneeMulti(e,stepIndex,index) : null : null }        

                                        >
                                          <div className="flex-center width-120">
                                            <span className="pl-0"> {phase.allowMultiAssignee ? "Multi Assignee"  : "Single Assignee"}
                                            </span>
                                            {ActiveAssigneeManIcon}
                                          </div>

                                          {options?.features ?.MULTI_ASSIGNEE_PHASE ? 
                                            ( isFullWorkflowEditEnabled() && multiAssigneeEditable(step, phase, index) ? ( DownArrowIconWorkflow ) : null ) 
                                            : null}
                                        </div>
                                        {showEditMultiAssignee ===
                                        `step${stepIndex}phase${index}` ? (
                                          <EditMultiAssignee phase={phase} step={step} phaseIndex={index} stepIndex={stepIndex} />
                                        ) : null}
                                      </div>
                                      {phase.phaseType?.originalEnum === "REVIEW" ? (
                                        <div className="step-assignee">
                                          {phase.isApprovalPhase ? (
                                            <div className="step-assignee flex-center" role="button" id={`review${stepIndex}phase${index}`} tabIndex={ isFullWorkflowEditEnabled() ? 0 : ''} aria-expanded={showEditReviewApprove === `step${stepIndex}phase${index}` ? true : false}
                                              onClick={isFullWorkflowEditEnabled() ? (e) =>toggleReviewApprove(e,stepIndex,index) : null }
                                              onKeyDown={isFullWorkflowEditEnabled() ? (e) =>toggleReviewApprove(e,stepIndex,index) : null}  
                                            >
                                              <span>Approval</span>
                                              {DownArrowIconWorkflow}
                                            </div>
                                          ) : (
                                            <div className="step-assignee flex-center" role="button" aria-expanded={showEditReviewApprove === `step${stepIndex}phase${index}` ? true : false} tabIndex={ isFullWorkflowEditEnabled() ? 0 : ''} id={`review${stepIndex}phase${index}`}
                                            onClick={isFullWorkflowEditEnabled() ? (e) => toggleReviewApprove(e,stepIndex,index) : null}
                                            onKeyDown={isFullWorkflowEditEnabled() ? (e) =>toggleReviewApprove(e,stepIndex,index) : null} 
                                            >
                                              <span>Review</span>
                                              {isFullWorkflowEditEnabled() ? (
                                                DownArrowIconWorkflow
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          )}
                                          {showEditReviewApprove === `step${stepIndex}phase${index}` ? (
                                            <EditReviewApprove phase={phase} step={step} phaseIndex={index} stepIndex={stepIndex} />
                                          ) : null}
                                        </div>
                                      ) : null}
                                      {phase.isApprovalPhase ? (
                                        <>
                                          <span>Phase on rejection :</span>
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center" tabIndex={0} id={`return${stepIndex}phase${index}`} aria-expanded={showPhaseOnRemoval === `step${stepIndex}phase${index}` ? true : false} role="button"
                                              onKeyDown={(e) =>togglePhaseOnRejection(e,stepIndex,index)}
                                              onClick={(e) =>togglePhaseOnRejection(e,stepIndex,index)} >
                                              {phase.returnPhaseNumber !== "" ? ( getPhaseName(step, phase) ) : 
                                              (
                                                <span dangerouslySetInnerHTML={{ __html: phase.returnPhaseDisplay ? phase.returnPhaseDisplay : phase?.returnPhases ?.length > 0 ? phase?.returnPhases[0] ?.displayText : null, }}></span>
                                              )}
                                              {DownArrowIconWorkflow}
                                            </div>
                                            {showPhaseOnRemoval === `step${stepIndex}phase${index}` ? (
                                              <EditPhaseOnRejection phase={phase} step={step} phaseIndex={index} stepIndex={stepIndex} />
                                            ) : null}
                                          </div>
                                        </>
                                      ) : null}
                                      {(isFullWorkflowEditEnabled && reviewModeEditable(phase, step, index)) &&
                                      phase.isApprovalPhase === false ?
                                      (<>
                                          <ConditionalBlock condition={phase.phaseType.code !== Constants.PHASE_TYPE_PE}>
                                            <div className="step-assignee">
                                            <div className="step-assignee flex-center" tabIndex={0} id={`permission${stepIndex}phase${index}`} role="button" aria-expanded={showEditPermissions === `step${stepIndex}phase${index}` ? true : false}
                                              onClick={(e) =>togglePermission(e,stepIndex, index)}
                                              onKeyDown={(e)=>togglePermission(e,stepIndex, index)}
                                            >
                                              <span>Permissions</span>
                                              {DownArrowIconWorkflow}
                                            </div>
                                            {showEditPermissions === `step${stepIndex}phase${index}` ? 
                                              <EditPermission phase={phase} step={step} phaseIndex={index} stepIndex={stepIndex} />
                                            : null}
                                            </div>
                                          </ConditionalBlock>
                                          <ConditionalBlock condition={phase.phaseType.originalEnum === "POST_EDITING"}>
                                            <div className="step-request">
                                              <div className="left-icon step-assignee">
                                                {RightArrowRequestRevision}
                                              </div>
                                              <span>Cannot Request Revision</span>
                                            </div>
                                          </ConditionalBlock>
                                        </>
                                      ) : (phase.phaseType.originalEnum === "REVIEW" || phase.phaseType.originalEnum === "POST_EDITING") ? (
                                        phase.allowRevision === true ? (
                                          <div className="step-request">
                                            <span className="revision-allowed pl-0">
                                              Can Request Revision
                                            </span>
                                            <div className="left-icon">
                                              {RecycleIconRequestRevision}
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="step-request">
                                            <div className="left-icon">
                                              {RightArrowRequestRevision}
                                            </div>
                                            <span>Cannot Request Revision</span>
                                          </div>
                                        )
                                      ) : phase.phaseType.originalEnum === "WORK" ? (
                                        <div className="step-request">
                                          <div className="left-icon step-assignee">
                                            {InactiveCannotRequestRevisionIcon}
                                          </div>
                                          <span>Cannot Request Revision</span>
                                        </div>
                                      ) : null
                                      }
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            {stepIndex !== 0 && isFullWorkflowEditEnabled() ? (
                              <div className="workflow-remove-step">
                                <button onClick={() => removeStep(stepIndex, step.stepNumber) } >
                                  {MinusRemoveStepWorkflow}{" "}
                                  Remove Step
                                </button>
                              </div>
                            ) : null}
                           <ConditionalBlock condition={isFullWorkflowEditEnabled() && step.phases.length < Constants.MAX_PHASES_PER_WORKFLOW_STEP } >
                               <button className="add-workflow-btn" aria-label="add phase" key={stepIndex}
                                onClick={() => addPhase(stepIndex)}>
                                {PlusIconAddPhaseWorkflow}
                              </button>
                            </ConditionalBlock>
                            <ConditionalBlock condition={isFullWorkflowEditEnabled() &&
                            steps.length < options?.workflowStepsLimit} >
                                <button className="add-workflow-btn medium-workflow-btn" aria-label="add step" onClick={addStep}>
                                {PlusIconLargeAddPhaseWorkflow}
                              </button>
                            </ConditionalBlock>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                  {departActive() ? 
                    <>  
                  <div className="department-block mar-bot30">
                    <h6>
                      Departments{" "}
                      {validationErrors.userGroups ? (
                        <span style={{ marginBottom: "4px", color: "#A61616" }}>
                          {validationErrors.userGroups}
                        </span>
                      ) : validationErrors.group_with_no_workflow ? (
                        <span style={{ marginBottom: "4px", color: "#A61616" }}>
                          Please make sure that every department in your
                          organization has at least one workflow template to
                          create projects with. The follow departments do not
                          have a workflow template :{" "}
                          {validationErrors.group_with_no_workflow}
                        </span>
                      ) : (
                        ""
                      )}
                    </h6>
                     
                    <p>Which departments can use this workflow? </p>
                    <div className="flex wrap-dropdown mb-0">
                      <div className="global-dropdown-block">
                        {/* <label>Departments {validationErrors.userGroups ? <span style={{marginBottom:'4px',color:"#A61616"}}>{validationErrors.userGroups}</span> : ''}</label> */}
                        <Select
                          classNamePrefix="cw"
                          className="global-dropdown-select"
                          value={departments.filter(function (option) {
                            if (selectedDepartment.value !== "") {
                              return option.value.id === selectedDepartment?.id;
                            }
                          })}
                          aria-label="Departments"
                          placeholder={"Select Department"}
                          options={departments}
                          onChange={(e) => selectDepartments(e)}
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                        />
                      </div>
                    </div>
                    <div className="multiselect-output flex">
                      <div>
                        {defautSelectedDeparts.map((depart, index) => {
                          return (
                            <button
                            aria-label={"remove  "  +  depart.name}
                              key={index}
                              onClick={() => removeDepartment(depart)}
                            >
                              <strong>{depart.name}</strong>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                              >
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div> </>
                    : ''}
                 
                  
                    {isAutomaticTmSync() ? (
                      <div className="additional-option">
                        <h6>Additional Options</h6>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="chk2"
                            checked={isChecked}
                            onChange={(e) => setAutomaticSync(e)}
                          />
                          <label className="form-check-label" htmlFor="chk2">
                            Automatic TM Sync
                          </label>
                        </div>
                      </div>
                    ) : null}
                  
                 
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex equal-height">
          <div>
            <button
              className="btn-default"
              onClick={() => navigate("/settings/review-workflow")}
            >
              Cancel
            </button>
          </div>

          {(isFullWorkflowEditEnabled() || departActive()) ?
          options?.features?.ENABLE_LANGUAGE_REVIEWER_TEMPLATE ? 
            <>
            <div>
              <button
                className="btn-default"
                onClick={() => {saveWorkflow('no_redirect')}}
              >
                Add Language Reviewers
              </button>
            </div>
          </>
          : '' :''}
           <div>
            <button className="btn-default" onClick={()=>saveWorkflow('')}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
